import { Component, OnInit, AfterViewInit, AfterContentInit ,OnChanges, SimpleChanges, Input, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../dynamic-form/dynamicForm.interface';
import { CustomSwitchOptions } from './custom-switch.interface';
import { slideDownUp } from '../global-app-animations';
import { MatSlideToggle } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-custom-switch',
    templateUrl: './custom-switch.component.html',
    styleUrls: ['./custom-switch.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [slideDownUp],
    standalone: false
})
export class CustomSwitchComponent implements OnInit,AfterContentInit , AfterViewInit, OnChanges {

  @ViewChild('switchI') switchEl: MatSlideToggle | undefined;

  @Input() options: CustomSwitchOptions | undefined; 
  @Input() field!: FieldConfig;
  @Input() group!: FormGroup;  

  // comunica quando cambia lo stato dello switch
  @Output() changedValue: EventEmitter<any> = new EventEmitter<any>();

  parsedOptions: CustomSwitchOptions | undefined;
  parsedData: boolean | undefined;

  @Input() switchValue: any;

  constructor(

  ) {

  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    //this.switchEl!.setProperties(this.group ? this.field?.options! : this.parsedOptions! );    
  }

  ngAfterContentInit(): void {
    // imposto auto focus se serve
    /*if(this.field != undefined && this.field.autoFocus != undefined && this.field.autoFocus != false) {
      console.warn(this.field.name);
      let le = document.getElementById(this.field.name)!.getElementsByTagName("input");
      for(let i = 0; i < le!.length; i++){
        le[i].focus();
      }
    }*/
  }

  ngOnChanges(changes:SimpleChanges): void {
    if (!this.group) {
      
    }
  }

  // eseguita quando cambia lo stato dello switch
  onChange(event:any) {
    this.changedValue.emit(event);
  }


}
